import React, { useEffect, useState, useRef } from "react";
import { Box } from "@mui/material";
import TurnRightIcon from "@mui/icons-material/TurnRight";
import IconButton from "@mui/material/IconButton";
import {
  Aria,
  Vdara,
  Bellagio,
  ParkMGM,
  TCOLV,
  DistrictHighlight,
  Nomad,
} from "../list/listItems";
import { useTheme, createTheme } from "@mui/material/styles";
import { useStoreDollHouseMap } from "../store";
import { useMediaQuery } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import $ from "jquery";

import { __mobileHideBar } from "../layouts/SideBar";
import { __closeInfoTab } from "../layouts/InfoTab";

let showDollHouseModal, setshowDollHouseModal;
let _mouseX, set_mouseX;
let _mouseY, set_mouseY;
let _hoverContent, set_hoverContent;
let _activeContent, set_activeContent;
let selectedHotid, sethotId;
let mobilepopupdirection, setmobilepopupdirection;
let mobilepopupdirectionClose, setmobilepopupdirectionClose;
// let divRef;
export function __showDollHouseModal(visibile, mouseX, mouseY, id) {
  // console.log('mouseX, mouseY', mouseX, mouseY);
  // console.log('----divRef.current.clientHeight');
  // console.log(divRef.current.clientHeight);
  // if (id === null || id === undefined || id === '') return;
  // console.log("id", id);

  if (id === "cosmo_level_2_restaurent") {
    id = "cosmo_district";
  }
  if (id === "cosmo_level_3_restaurent") {
    id = "cosmo_district";
  }
  if (id === "cosmo_level_1_restaurent") {
    id = "cosmo_district";
  }

  // if (setshowDollHouseModal) {
  setshowDollHouseModal(visibile);
  // }

  // if (set_mouseX) {
  set_mouseX(mouseX);
  // }
  // if (set_mouseY) {
  set_mouseY(mouseY);
  // }

  if (setmobilepopupdirection && id) {
    if (id.includes("bellagio")) {
      setmobilepopupdirection("0");
      setmobilepopupdirectionClose(false);
    } else {
      setmobilepopupdirection("calc(100% - 210px) !important");
      setmobilepopupdirectionClose(true);
    }
    __mobileHideBar();
    __closeInfoTab();
  }
  if (selectedHotid) {
    selectedHotid(id);
  }

  // console.log(_hoverContent.hoverContent);
  // _hoverContent.hoverContent
  let _data;
  if (_hoverContent) {
    //console.log(_hoverContent)
    _data = _hoverContent.hoverContent.find((bird) => bird.dom_id === id);
  }

  if (set_activeContent) {
    set_activeContent(_data);
  }
}
export function HideDollHouseModal() {
  setshowDollHouseModal(false);
}
export default function HotspotInfoModal(hoverContent) {
  // console.log('11111', _mouseY);
  const dollhouseStore = useStoreDollHouseMap();
  const [link, setLink] = useState(null);
  const [poiObj, setPoiObj] = useState(null);
  const [poidactive, setPoidactive] = useState(false);
  [showDollHouseModal, setshowDollHouseModal] = useState(false);
  [_mouseX, set_mouseX] = useState(0);
  [_mouseY, set_mouseY] = useState(0);
  [selectedHotid, sethotId] = useState(null);
  [mobilepopupdirection, setmobilepopupdirection] = useState("0");
  [mobilepopupdirectionClose, setmobilepopupdirectionClose] = useState(true);

  [_hoverContent, set_hoverContent] = useState(hoverContent);
  [_activeContent, set_activeContent] = useState();
  const theme = useTheme();
  const _customTheme = createTheme({
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 1000,
        lg: 1200,
        xl: 1536,
      },
    },
  });
  const divRef = useRef(null);
  const _xs = useMediaQuery(_customTheme.breakpoints.only("xs"));
  const _sm = useMediaQuery(_customTheme.breakpoints.only("sm"));

  useEffect(() => {
    // document.addEventListener("mousedown", (event) => {
    //   //setshowDollHouseModal(false);
    // });

    if (hoverContent.link !== "") {
      setLink(hoverContent.link);
    }
    let arrayData = null;

    arrayData = Bellagio.filter((val) => {
      if (val.poiId === hoverContent.dom_id && val.isActive === true) {
        return val;
      }
    });

    if (arrayData.length === 0) {
      arrayData = Aria.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length === 0) {
      arrayData = Vdara.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length === 0) {
      arrayData = ParkMGM.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length === 0) {
      arrayData = TCOLV.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length === 0) {
      arrayData = DistrictHighlight.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length === 0) {
      arrayData = Nomad.filter((val) => {
        if (val.poiId === hoverContent.dom_id && val.isActive === true) {
          return val;
        }
      });
    }

    if (arrayData.length > 0) {
      setPoiObj(arrayData[0]);
      if (arrayData[0].isActive) {
        setPoidactive(true);
      }
    } else {
      setPoidactive(false);
    }

    // divRef.current.style.visibility = "hidden";
  }, []);

  const handleInformationClickEvent = (e) => {
    let refirectLink = e.target.dataset.link;
    if (refirectLink !== null) {
      window.open(refirectLink, "_blank");
    }
  };

  const selectPoiPoint = () => {
    // console.log(poiObj);
    if (poiObj !== null) {
      dollhouseStore.updatePOIPointAreaSelection(poiObj);
    }
  };

  const showPopup = () => {
    // console.log(_activeContent);
    // console.log('---mouseX, mouseY', _mouseX, _mouseY);
    // console.log('----divRef.current.clientHeight');
    // console.log(divRef.current.clientHeight);
    if (_activeContent && _activeContent.dom_id) {
      if (document.getElementById(_activeContent.dom_id)) {
        let domid = _activeContent.dom_id;
        let cb = setTimeout(() => {
          document.getElementById(domid).classList.add("active-poi");
          clearTimeout(cb);
        }, 0);
      }
    }
    // console.log(divRef.current.clientHeight);
    // if (divRef.current) {
    //   divRef.current.style.visibility = "visible";
    //   divRef.current.classList.add("mouse-in");
    // }
  };
  const hidePopup = () => {
    // console.log(_activeContent);
    __showDollHouseModal(false, 0, 0, "");
    if (_activeContent) {
      if (_activeContent["dom_id"]) {
        let domid = _activeContent["dom_id"];

        if (document.getElementById(domid)) {
          let cb = setTimeout(() => {
            document.getElementById(domid).classList.remove("active-poi");

            clearTimeout(cb);
          }, 0);
        }
      }
    } else {
      let cb = setTimeout(() => {
        $(".poi-hover").removeClass("active-poi");
        clearTimeout(cb);
      }, 0);
    }
    setshowDollHouseModal(false);
    // __showDollHouseModal(false, 0, 0, "");

    //dollhouseStore.hideSvgPopUp();
    //setOpacity(opacity);
    // if (divRef.current) {
    // setTimeout(() => {
    // }, 5000);
    //
    // const timeoutId = setTimeout(() => {
    // divRef.current.style.visibility = "hidden";
    // divRef.current.classList.remove("mouse-in");
    //   clearTimeout(timeoutId);
    // }, 100);
    // clearTimeout(timeoutId);
    // }
  };
  // let reactHeight = document.getElementById("hotspot_info").clientHeight;
  // if (reactHeight != null) {
  //   console.log("------------", reactHeight);

  // }
  return (
    <Box
      id="hotspot_info_container"
      component="div"
      sx={{
        display: showDollHouseModal ? "block" : "none",
      }}
      onMouseLeave={() => {
        if (_xs || _sm) {
          return;
        } else {
          //  console.log("hide");
          hidePopup();
        }
      }}
    >
      {mobilepopupdirectionClose ? (
        <IconButton
          onClick={() => {
            setshowDollHouseModal(false);
          }}
          sx={{
            background: "#000000",
            color: "#FFFFFF",
            position: "absolute",
            right: "211px",
            top: "10px",
            height: "35px",
            width: "35px",
            padding: "2px",
            border: "none",
            display: { sm: "block", md: "none" },
            [_customTheme.breakpoints.down("md")]: {
              zIndex: 14,
            },
          }}
        >
          <CloseIcon
            sx={{
              height: "auto",
              width: "100%",
            }}
          />
        </IconButton>
      ) : (
        <IconButton
          onClick={() => {
            setshowDollHouseModal(false);
          }}
          sx={{
            background: "#000000",
            color: "#FFFFFF",
            position: "absolute",
            top: "10px",
            height: "35px",
            width: "35px",
            left: "211px",
            padding: "2px",
            border: "none",
            display: { sm: "block", md: "none" },
            [_customTheme.breakpoints.down("md")]: {
              zIndex: 14,
            },
          }}
        >
          <CloseIcon
            sx={{
              height: "auto",
              width: "100%",
            }}
          />
        </IconButton>
      )}

      <Box
        ref={divRef}
        onMouseEnter={() => {
          if (_xs || _sm) {
            return;
          } else {
            showPopup();
          }
        }}
        onMouseLeave={() => {
          if (_xs || _sm) {
            return;
          } else {
            hidePopup();
          }
        }}
        className="hotspt_infr_outer"
        data-id="1"
        component="div"
        id="hotspot_info"
        sx={{
          [_customTheme.breakpoints.down("md")]: {
            top: "0 !important",
            left: mobilepopupdirection,
            height: "100%",
            zIndex: 1200,
            width: "210px",
          },
          [_customTheme.breakpoints.up("md")]: {
            top:
              _mouseY > window.innerHeight - 230
                ? `${
                    _mouseY -
                    (divRef.current.clientHeight <= 0
                      ? 190
                      : divRef.current.clientHeight)
                  }px`
                : `${_mouseY}px`,
            left:
              _mouseX > window.innerWidth - 180
                ? `${_mouseX - 200}px`
                : `${_mouseX}px`,
          },
        }}
      >
        <input type="hidden" id="hotspo_poover_id" />
        <h4>{_activeContent?.title}</h4>
        <p style={{ fontFamily: "'Trade Gothic LT Std', sans-serif" }}>
          {_activeContent?.information}
        </p>
        <i className="fa fa-car"></i>

        {poidactive && (
          <IconButton
            type="button"
            sx={{
              background: "transparent",
              border: "2px solid #BDA770",
              borderRadius: "5px",
              padding: 0,
              "&:hover": { color: "#BDA770" },
            }}
            aria-label="search"
            onClick={selectPoiPoint}
          >
            <TurnRightIcon sx={{ color: "#BDA770" }} />
          </IconButton>
        )}

        {_activeContent?.link && (
          <IconButton
            id="info-hotspot-btn"
            onClick={handleInformationClickEvent}
            data-link={_activeContent?.link}
            sx={{
              cursor: "pointer",
              font: "normal normal 600 11px/15px Segoe UI",
              color: "black",
            }}
          >
            View Now
          </IconButton>
        )}
      </Box>
    </Box>
  );
}
